module.exports = __webpack_public_path__ + "static/index/img/baikal-407.b78b2e0d.jpg";